var $ = require("jquery");
var Modernizr = require("../vendors/modernizr.min");

// prepend the base URL for JS (CDN domain, if one is used for JS) to the webpack public path
__webpack_public_path__ = __webpack_public_path__.startsWith(ws_cssAndJsServerUrl) ? __webpack_public_path__ : ws_cssAndJsServerUrl + __webpack_public_path__;
// importing the FusionCharts packages inexplicably clears the webpack public path!!!! so we have to grab the original value and then restore it after loading
const webpackPublicPath = __webpack_public_path__;

var TransEndEventNames = {
    "WebkitTransition": "webkitTransitionEnd", // Saf 6, Android Browser
    "MozTransition": "transitionend",          // only for FF < 15
    "transition": "transitionend"              // IE10, Opera, Chrome, FF 15+, Saf 7+
};

function bindFormSubmitHandler($form) {
    // jQuery unobtrusive binds the invalidHandler function on page load. It can't be overridden in the jQuery validate settings,
    // so this is the preferred way to override that. We're doing that here and disabling focusInvalid in the jQuery validation defaults
    // so that we can smooth scroll to the first invalid field, instead of jumping.
    // This function is also exposed so that custom forms can call it after an ajax submit.
    $form = ($form && $form.length) ? $form : $("form");
    $form.bind("invalid-form.validate", function () {
        var validator = $(this).data("validator");

        if (!validator || !validator.numberOfInvalids()) {
            return;
        }

        var $firstInvalidField = $(validator.errorList[0].element);
        if ($firstInvalidField.length) {
            // find the label or the legend, whichever is higher on the page
            var $label = $form.find(`[for='${validator.errorList[0].element.id}']`);
            var $fieldset = $firstInvalidField.parents("fieldset");
            var $scrollTarget = $fieldset.length && $fieldset.offset().top < $label.offset().top ? $fieldset : $label;

            scrollFormTo($(this), $scrollTarget, null, $firstInvalidField);
        }
    });
}

function isFixedElementOverFooter($element, $footer) {
    var elementOffset = $element.offset(),
        elementHeight = $element.height(),
        elementY = elementOffset.top + (elementHeight / 2),

        $blueFooterSection = $footer.children(".ws-footer-section--main, .ws-footer-section--side-by-side").first(),
        blueFooterTop = $blueFooterSection.offset().top,
        blueFooterBottom = blueFooterTop + $blueFooterSection.height();

    return (blueFooterTop <= elementY) && (elementY <= blueFooterBottom);
}

function getFixedElements() {
    return $(".ws-nav, .ws-in-page-nav, .ws-minified-header");
}

function getFixedElementsHeight() {
    var bottomOfLowestFixedElement = 0;
    var $fixedElements = getFixedElements();

    $fixedElements.each(function (index, element) {
        var elementBottom = element.getBoundingClientRect().bottom;
        if (elementBottom > bottomOfLowestFixedElement) {
            bottomOfLowestFixedElement = elementBottom;
        }
    });

    return bottomOfLowestFixedElement;
}

function scrollFormTo($form, $el, offset, $focusTarget) {
    var $dialogContentWrapper = $form.parents(".ws-dialog__content-wrapper");
    var $scrollTarget = $dialogContentWrapper.length ? $dialogContentWrapper : $("html, body");
    var scrollTop;

    if (!$el || !$el.length) {
        $el = $form.children(":first");
    }

    if (offset === undefined || offset === null) {
        if ($dialogContentWrapper.length) {
            offset = $form.offset().top + $dialogContentWrapper.offset().top + 5;
        } else {
            offset = getFixedElementsHeight() + 15;
        }
    }

    scrollTop = $el.offset().top - offset;

    $focusTarget = $focusTarget || ($el.is(":tabbable") ? $el : $el.find(":tabbable").first());

    scrollToPosition($scrollTarget, scrollTop, () => $focusTarget.focus());
}

function scrollFormToCenter($form, $el) {
    const offset = (window.innerHeight - $el.outerHeight() + getFixedElementsHeight()) / 2;
    scrollFormTo($form, $el, offset);
}

function scrollToPosition($scrollTarget, position, callback) {
    $scrollTarget.stop(true).animate({ scrollTop: position }, 100, function () {
        if (callback && typeof callback === 'function') {
            callback();
        }
    });
}

function replaceTag($element, newTagName) {
    // replaces an element's tag with a new one, preserving all attributes and inner html (HTMLElement.tagName is immutable)
    var originalElement = $element[0];
    var originalTag = originalElement.tagName;
    var startTagRegExp = new RegExp('^<' + originalTag, 'i');
    var endTagRegExp = new RegExp(originalTag + '>$', 'i');
    var startTagReplace = '<' + newTagName;
    var endTagReplace = newTagName + '>';
    var newHtml = originalElement.outerHTML
        .replace(startTagRegExp, startTagReplace)
        .replace(endTagRegExp, endTagReplace);

    return $element.replaceWith(newHtml);
}

window.requestIdleCallback =
    window.requestIdleCallback ||
    function (cb) {
        var start = Date.now();
        return setTimeout(function () {
            cb({
                didTimeout: false,
                timeRemaining: function () {
                    return Math.max(0, 50 - (Date.now() - start));
                }
            });
        }, 1);
    };

window.cancelIdleCallback =
    window.cancelIdleCallback ||
    function (id) {
        clearTimeout(id);
    };

$(function () {
    // From this jQuery issues GitHub discussion: https://github.com/jquery/jquery/issues/2871
    // jQuery suggests this workaround to enable passive touchstart event listeners
    jQuery.event.special.touchstart = {
        setup: function (_, ns, handle) {
            this.addEventListener("touchstart", handle, { passive: true });
        }
    };

    // This fixes an issue specific to iOS Safari where clicking a link that is not originally within the viewport when the page loads does not trigger the hover style
    if (Modernizr.browsertouch) {
        $('a').on('touchstart', function () { });
    }

    bindFormSubmitHandler();

    $(document).on('click', 'a:not(.ws-in-page-nav__link):not(.ws-nav-tabs__link):not(.ws-table-of-contents__link):not(.option)[href^="#"]', function (e) {
        if (this.pathname === window.location.pathname) {
            var buffer = 45;
            var scrollTop = null;
            var anchorElement = $.attr(this, 'href').replace('#', '');
            if (!anchorElement) {
                return;
            }

            let matchingElementOffset = $(`[id='${anchorElement}']:visible,[name='${anchorElement}']:visible`).offset();
            if (matchingElementOffset) {
                scrollTop = matchingElementOffset.top;
            }

            if (scrollTop) {
                e.preventDefault();

                scrollTop = scrollTop - getFixedElementsHeight() - buffer;
                var $scrollTarget = $("html, body");
                scrollToPosition($scrollTarget, scrollTop);
            }
        }
    });
});

exports.bindFormSubmitHandler = bindFormSubmitHandler;

exports.getTransitionEndEventName = function () {
    return TransEndEventNames[Modernizr.prefixed("transition")];
};

exports.isExperienceEditor = function () {
    return typeof Sitecore !== "undefined" && typeof Sitecore.PageModes !== "undefined" && typeof Sitecore.PageModes.PageEditor !== "undefined";
};

exports.resetChromes = function () {
    Sitecore.PageModes.ChromeManager.resetChromes();
};

exports.queryString = (function () {
    const params = window.location.search.substr(1).split("&");
    let results = {};

    for (const param of params) {
        const paramArray = param.split("=");

        if (paramArray.length !== 2) {
            continue;
        }

        results[paramArray[0].toLocaleLowerCase()] = decodeURIComponent(paramArray[1].replace(/\+/g, " "));
    }

    return results;
})();

exports.scrollToValidationErrors = function () {
    var $validationSummaryErrors = $(".validation-summary-errors");

    if ($validationSummaryErrors.length) {
        scrollFormTo($(this), $validationSummaryErrors);
    }
};

exports.webpackPublicPath = webpackPublicPath;
exports.cssAndJsServerUrl = ws_cssAndJsServerUrl;
exports.replaceTag = replaceTag;
exports.scrollFormTo = scrollFormTo;
exports.scrollFormToCenter = scrollFormToCenter;
exports.getFixedElements = getFixedElements;
exports.getFixedElementsHeight = getFixedElementsHeight;
exports.isFixedElementOverFooter = isFixedElementOverFooter;
exports.lazyLoadingEnabled = window.WS && window.WS.lazyLoadingEnabled;

window.WS = exports;